import { createContext } from "react";

export const TableDataContext = createContext([]);
